
export const UserStatus = {
	active: 'Active',
	inactive: 'Inactive',
	pending: 'Pending',
	removed: 'Removed',
	crmonly: 'CRM Only',
}

export const RegistrationStatus = {
	accepted: 'Accepted',
	pending: 'Pending',
	removed: 'Removed',
}

export const OrganizationStatus = {
	active: 'Active',
	inactive: 'Inactive',
	pending: 'Pending',
	removed: 'Removed',
}

export const ApplicationStatus = {
	active: 'Active',
	beta: 'Beta',
	inactive: 'Inactive',
	restricted: 'Restricted',
	removed: 'Removed'
}

export const ResourceStatus = {
	active: 'Active',
	beta: 'Beta',
	inactive: 'Inactive',
	restricted: 'Restricted',
	removed: 'Removed'
}

export const ResourceType = {
	connected: 'Connected',
	embedded: 'Embedded'
}

export const ResourceAccess = {
	all: 'All Users',
	alist: 'A-List',
}

export const ResourceCategory = {
	risk: `Risk and Analysis`,
	market: `Market Data`,
	calculators: `Calculators`,
	commentary: `Commentary and Events`,
}

export const BannerStatus = {
	active: 'Active',
	inactive: 'Inactive',
	pending: 'Pending',
	removed: 'Removed',
}

export const DomainStatus = {
	active: 'Active',
	removed: 'Removed',
}


export const invert = (obj) => Object.fromEntries(Object.entries(obj).map(([k, v]) => [v, k]))
